import { storage } from "@/main";

export default {
    getID() {
        return Math.random().toString(36).substr(2, 9)
    },
    async post(file, path) {
        let metadata = {
            contentType: 'application/gzip',
        };
        return storage.ref(path).put(file, metadata).then((res) => {
            return res.ref.getDownloadURL().then((url) => {
                return url
            })
        }).catch((e) => {
            return e
        });
    },
    async postArray(files, ref, subject, type) {
        let result = []
        for (const item of files) {
            if(item.file && item.file.name) {
                let ext = item.file.name.substr(item.file.name.lastIndexOf('.') + 1)
                let path = 'requests/' + ref + '/' + type + '/' + (subject === null ? '' : subject + '_') + type + '_' + this.getID() + '.' + ext
                let url = await this.post(item.file, path)
                result.push(url)
            } else {
                result.push(item)
            }
        }
        return result
    }
}
